var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlgorandLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200ZM74.4838 125.985L55.7375 158.333H33.3333L52.0796 125.985L70.7117 93.75L89.458 61.4014L107.747 29.8501L108.204 29.1667H127.751L128.665 32.5838L135.752 59.0094L136.438 61.4014H156.785L142.839 85.435L145.125 93.75L153.813 125.985L162.5 158.333H142.382L133.695 125.985L129.122 109.241L119.406 125.985L100.66 158.333H78.2559L96.8879 125.985L115.634 93.75L122.035 82.7014L116.32 61.4014L114.948 56.2757L111.862 61.4014L93.2301 93.75L74.4838 125.985Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorandLogo);
export default __webpack_public_path__ + "static/media/Algorand-logo.1dffc2983abae69e501710b04f903ebd.svg";
export { ForwardRef as ReactComponent };